import React from 'react';
import { navigate } from 'gatsby';
import { Snackbar, SnackbarContent, Link, IconButton, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ParagraphComponent } from 'common-app/paragraph';
import { getStoredValue, setStoredValue } from 'common/helpers';
import { namespaces } from 'core/i18n';
import { LOCAL_STORAGE_KEYS } from 'core/constants';
import CloseIcon from 'core/assets/icons/close.svg';
import { routes } from 'core/router';
import { CookiesConfig } from './components';
import { keys } from './translations';
import * as classes from './cookies-popup.styles';

export const CookiesPopupComponent: React.FunctionComponent = () => {
  const { t } = useTranslation(namespaces.commonApp.cookesPopup);
  const [isOpenDialog, setIsOpenDialog] = React.useState<boolean>(false);
  const [isOpenPopup, setIsOpenPopup] = React.useState<boolean>(
    () => getStoredValue(LOCAL_STORAGE_KEYS.COOKIES_ALERT) ?? true
  );

  const handleClosePopup = () => setIsOpenPopup(false);
  const handleCloseDialog = () => setIsOpenDialog(false);
  const handleOpenDialog = () => setIsOpenDialog(true);
  const handleClosePopupForever = () => {
    handleClosePopup();
    setStoredValue(LOCAL_STORAGE_KEYS.COOKIES_ALERT, false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        open={isOpenPopup}
        sx={{ width: '100%' }}
      >
        <SnackbarContent
          className={classes.root}
          message={
            <div className={classes.content}>
              <div className={classes.textContainer}>
                <ParagraphComponent label={t(keys.title)} />
                <ParagraphComponent
                  label={t(keys.linkLabel)}
                  componentInterpolation={[
                    <Link
                      key={0}
                      onClick={() => {
                        navigate(routes.cookies);
                      }}
                    />,
                  ]}
                />
              </div>
              <div className={classes.buttonContainer}>
                <Button variant="outlined" onClick={handleOpenDialog} color="secondary">
                  {t(keys.settings)}
                </Button>
                <Button variant="contained" onClick={handleClosePopupForever}>
                  {t(keys.rejectAll)}
                </Button>
                <Button variant="contained" onClick={handleClosePopupForever} color="secondary">
                  {t(keys.acceptAll)}
                </Button>
              </div>
            </div>
          }
          action={[
            <IconButton key="close" color="inherit" onClick={handleClosePopup}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
      <CookiesConfig
        isOpen={isOpenDialog}
        onClose={handleCloseDialog}
        onAccept={() => {
          handleCloseDialog();
          handleClosePopupForever();
        }}
      />
    </>
  );
};
